export const checkIfUserComIsEnabled = userCom => {
  const { apiKey, appSubdomain } = userCom || {};
  return !!appSubdomain && !!apiKey;
};
